import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Select as ChakraSelect, } from '@chakra-ui/react';
import { ThemeIconSizeVariable, } from '@caspeco/casper-ui-library.base-ui.theme';
import { Icon, Icons } from '@caspeco/casper-ui-library.components.icon';
export const Select = React.forwardRef(({ children, size = 'md', variant = 'outline', ...props }, ref) => {
    const renderIcon = React.useCallback(() => {
        if (variant === 'ghost') {
            // Ghost variant does not have an arrow icon, so we return an empty fragment
            return _jsx(_Fragment, {});
        }
        return (_jsx(Icon, { icon: Icons.TreeViewCollapse, size: ThemeIconSizeVariable.Small }));
    }, [variant]);
    return (_jsx(ChakraSelect, { ref: ref, size: size, icon: renderIcon(), variant: variant, ...props, children: children }));
});
//# sourceMappingURL=select.js.map